var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgIconArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 6,
  fill: "none",
  strokeLinecap: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#165C7D",
  d: "m1 1 4 4 4-4"
})));
export { SvgImgIconArrowDown as ReactComponent };
export default __webpack_public_path__ + "img/img-icon-arrow-down.7b8576e539c9c282b8eeb214b0983ba4.svg";